module.exports = __webpack_public_path__ + "static/media/chevron-down.558345c4.svg";